module.exports = __webpack_public_path__ + "static/Bild5-c4c592ac02301e85cc4e329901617f7d.png";